import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    const onClick = () => map.commands.exportReq(
        {expBizFlag: '0', includeBdLogicFlag: '1'}
    )

    return {
        key: 'export-dev-req2',
        label: '导出软件需求文档2',
        title: '含处理逻辑',
        onClick,
    }
}
